import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-fh-svg-loading',
  templateUrl: './fh-svg-loading.component.html',
  styleUrl: './fh-svg-loading.component.scss'
})
export class FhSvgLoadingComponent {
  @Input() color: string = '';
}
